import ArticleLayout from '../article/components/ArticleLayout';
import { articles } from '@/mocks/articles';

export default function BezpieczenstwoPage() {
  return <ArticleLayout article={articles[1]} />;
}